import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { Accordion } from '@gemini/ui';
import Redirection from '@/components/Redirection';
import BlockTitle from '@/components/structure/BlockTitle';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
export const FrequentlyAskedQuestions = ({ pageConfiguration, landingType, data, }) => {
    const { t } = useTranslation();
    const items = data.items.map((item) => {
        return {
            title: t(item.title),
            content: typeof item.text === 'string' ? t(item.text) : item.text,
        };
    });
    return (_jsxs(Container, { paddingVertical: {
            'breakpoint.base': 'spacing.32',
            'breakpoint.lg': 'spacing.80',
        }, children: [_jsx(Box, { textAlign: "center", children: _jsx(BlockTitle, { as: "h2", children: t(data.title) }) }), _jsx(Box, { maxWidth: "738px", marginHorizontal: "auto", whiteSpace: 'pre-line', children: items.map((item) => (_jsx(Accordion, { titleSize: "16", variant: "divided", title: item.title, content: item.content, titleAs: "h3" }, item.title))) }), _jsx(Box, { textAlign: "center", marginTop: "spacing.32", children: _jsx(Redirection, { pageConfiguration: pageConfiguration, landingType: landingType }) })] }));
};
